import el_GR from './el-GR'
import en_US from './en-US'

const translations = {
	"el-GR": el_GR,
	"en-US": en_US
}

export default translations;